import storage from 'good-storage'
import http from '../lib/http'
import {loginInfoCache} from "../lib/cache/LoginInfo"
import {menuListCache} from "../lib/cache/MenuList";

export default {
    install(Vue) {
        /*添加实例属性*/
        Vue.prototype.$http = http;
        Vue.prototype.$cache = storage.session;
        Vue.prototype.$storage = storage;
        Vue.prototype.$env = process.env;


        /*全局Mixin*/
        Vue.mixin({
            data() {
                return {
                    env: process.env,
                    loadingQueued: [],
                    appShowLoading: false,
                    loginInfo: {},
                    menuList: [],
                    docDefaultAva: require('../assets/default_head_doc.png')
                }
            },
            computed: {
                docInfo() {
                    const {loginInfo} = this;
                    return loginInfo && loginInfo.doc ? loginInfo.doc : {};
                },
                docJobType() {// WESTERN_DOC西医 CHINESE_DOC中医
                    return this.docInfo && this.docInfo.docJobType
                }
            },
            async created() {
                this.menuList = menuListCache.get();
                this.loginInfo = loginInfoCache.get();
                bus.$on('loading', (res) => {
                    if (res !== false) {
                        this.appShowLoading = true;
                        this.loadingQueued.push(new Date());
                    } else {
                        this.loadingQueued.shift();
                        if (this.loadingQueued.length === 0) this.appShowLoading = false;
                    }
                })
            },
            methods: {}
        })
    }
}
